import ApiRoutes from "../config/api.routes";
import { User } from "../types";
import AxiosFactory from "./http.service";
import { consoleError } from "../utils/methods";
import { TrustOrganization } from "../types/trust";

async function authorize(account: string, data: string, signature: string) {
  const axiosFactory = new AxiosFactory();
  const res = await axiosFactory.axios.post(
    ApiRoutes.user.signIn,
    {
      address: account,
      data,
      sign: signature,
    },
    { withCredentials: false }
  );
  if (res.status === 201) {
    return {
      token: res.data.token,
      account: res.data as User,
    };
  } else {
    return false;
  }
}

export const fetchOrganization = async (): Promise<TrustOrganization | undefined> => {
  try {
    const { axios } = new AxiosFactory();
    return await axios.get(ApiRoutes.trust.myOrganization).then((res) => res.data);
  } catch (error: any) {
    consoleError("Failed to fetch organization info", { error });
    return undefined;
  }
};

async function checkAuth(): Promise<User | false> {
  if (loggedIn()) {
    const { axios } = new AxiosFactory();
    try {
      const res = await axios.get(ApiRoutes.user.root);
      if (res.data?.role === "trust") {
        const org = await fetchOrganization();
        return {
          ...res.data,
          organization: org,
        };
      }
      return res.data;
    } catch (e: any) {
      if (e?.response?.status >= 500 || e?.response?.status === 0) {
        return new Promise((resolve) => {
          setTimeout(async () => {
            try {
              const res = await axios.get(ApiRoutes.user.root);
              resolve(res.data);
            } catch {
              resolve(false);
            }
          }, 1000);
        });
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}

function logout() {
  localStorage.removeItem("token");
}

function loggedIn(): boolean {
  const token = getToken();
  return !!token;
}

function getToken(): string {
  const token = localStorage.getItem("token");
  return token !== null ? token : "";
}

function setToken(token: string) {
  localStorage.setItem("token", token);
}

export default {
  setToken,
  getToken,
  authorize,
  loggedIn,
  logout,
  checkAuth,
};
